import { InstructionColors } from '@riddler-co-jp/specc-ui-components';

export const CommInstructionLogo = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='388'
      height='60'
      viewBox='0 0 388 60'
    >
      <path
        d='M15.406,20.735a.816.816,0,0,1-.612-.132l-3.108-2.136a.816.816,0,1,1,.924-1.332l3.108,2.148a.8.8,0,0,1,.2,1.128.744.744,0,0,1-.516.324ZM12.886,26.9a.816.816,0,0,0-.768-.852l-3.78-.192a.816.816,0,0,0-.084,1.62l3.78.192h.192A.8.8,0,0,0,12.886,26.9Zm8.04-11.628a.8.8,0,0,0,.408-1.068l-1.512-3.468a.816.816,0,0,0-1.488.648l1.524,3.468a.792.792,0,0,0,.888.468Zm9.768-.144a3.108,3.108,0,0,1,.768.768h0l13.92,20,3.024.756h.072a1.476,1.476,0,0,1,.372.168c1.128.78.72,3.324-.912,5.676s-3.864,3.6-4.98,2.868a1.1,1.1,0,0,1-.312-.312h0l-1.8-2.592-23.556-5.9h-.156a2.928,2.928,0,0,1-.924-.42c-2.76-1.908-1.764-8.148,2.232-13.944S27.934,13.223,30.694,15.131Zm-.936,1.344c-.756-.528-2.232-.264-3.912.7a20.112,20.112,0,0,0-6.06,5.964A20.22,20.22,0,0,0,16.4,30.887c-.3,1.92,0,3.384.744,3.912s2.232.264,3.912-.7a20.256,20.256,0,0,0,6.06-5.916A20.292,20.292,0,0,0,30.5,20.435C30.8,18.467,30.526,17,29.758,16.475Z'
        transform='translate(1.514 2.065)'
        fill='#fff'
      />
      <path
        d='M30,0A30,30,0,1,0,60,30,30,30,0,0,0,30,0Zm0,57.6A27.6,27.6,0,1,1,57.6,30,27.6,27.6,0,0,1,30,57.6Z'
        fill='#fff'
      />
      <path
        d='M30.41,20.062v-1.49H20.334v.781c0,1.348-.781,2.519-3.229,2.519H15.934c-2.271,0-3.8-.816-3.8-3.37V14.492c0-2.306.851-3.512,3.654-3.512h1.135c2.235,0,3.229.745,3.229,2.235v.39H30.339V12.186C30.339,5.232,26.4,1.4,16.928,1.4H15.3C4.865,1.4,1.53,5.09,1.53,14.492V18.5c0,9.721,3.69,12.879,13.908,12.879h1.668C26.507,31.38,30.41,27.974,30.41,20.062Zm29.66,2.484V17.862c0-5.109-2.554-8.55-9.189-8.55H42.9c-6.457,0-9.366,3.087-9.366,8.657v4.4c0,5.677,2.838,8.728,9.366,8.728h7.983C57.515,31.1,60.07,27.69,60.07,22.545Zm-9.579-1.88a1.266,1.266,0,0,1-1.419,1.384H44.6c-1.206,0-1.455-.568-1.455-1.384v-.922A1.292,1.292,0,0,1,44.6,18.394h4.47a1.283,1.283,0,0,1,1.419,1.348Zm41.9,10.253V16.9c0-4.47-3.37-7.415-8.515-7.415H71.139c-5.18,0-8.515,2.945-8.515,7.415V30.918h9.4V20.1c0-.993.745-1.455,1.809-1.526V30.918H81.18V18.572c1.419,0,1.774.461,1.774,1.526V30.918Zm32.286,0V16.9c0-4.47-3.37-7.415-8.515-7.415H103.425c-5.18,0-8.515,2.945-8.515,7.415V30.918h9.4V20.1c0-.993.745-1.455,1.809-1.526V30.918h7.344V18.572c1.419,0,1.774.461,1.774,1.526V30.918ZM153.343,23.4V9.525H143.126V20.1c0,1.1-.426,1.419-1.171,1.419h-3.477c-.781,0-1.171-.568-1.171-1.419V9.525H127.125V23.4c0,5.57,2.661,7.557,7.344,7.557h11.5C150.612,30.954,153.343,28.257,153.343,23.4Zm29.341,7.521V17.224c0-4.719-3.158-7.734-7.947-7.734h-11.6c-4.79,0-7.451,3.016-7.451,7.734V30.918h10.324V20.736c0-1.135.781-1.809,2.093-1.809h2.271c1.242,0,1.916.461,1.916,1.809V30.918ZM196.557,9.95V1.932H186.374V9.95Zm0,20.968V11.582H186.374V30.918Zm29.518,0v-9.4h-14.44c-.958,0-1.419-.248-1.419-.851v-.851c0-.5.284-.851,1.384-.851h14.475V9.525H209.861c-7.309,0-9.615,3.477-9.615,9.154V21.8c0,5.748,2.129,9.118,9.65,9.118Zm30.157-5.641V17.9c0-5.428-1.774-8.479-7.912-8.479H229.978v7.273h14.9c.993,0,1.313.39,1.313,1.135h-10.5c-4.293,0-6.812,2.2-6.812,5.606v1.49c0,3.441,2.59,6,7.273,6h13.163C253.855,30.918,256.232,28.683,256.232,25.277ZM246.014,24c0,.426-.177.6-.781.6h-5.357c-.674,0-.852-.248-.852-.6v-.284c0-.355.177-.568.852-.568h5.357c.568,0,.781.284.781.568Zm38.53-5.18V9.489H273.013V5.445h-10.04V9.489h-4.435V18.82h4.435v5.109c0,4.222,2.093,6.989,7.983,6.989h13.092v-9.26H274.29c-1.135,0-1.277-.177-1.277-1.135v-1.7Zm28.986-1.987V15.7c0-3.867-2.306-6.351-6.954-6.351H294.017c-5.073,0-7.131,3.335-7.131,6.6v6.741c0,5.783,2.271,8.231,7.734,8.231h18.343V23.752H297.635c-1.135,0-1.455-.532-1.526-1.242h10.856C312.04,22.51,313.53,20.381,313.53,16.833Zm-9.544-.284c0,.532-.39.745-.922.745h-6.989v-.319a1.364,1.364,0,0,1,1.526-1.384h5.464c.6,0,.922.355.922.781Z'
        transform='translate(74.47 14.6)'
        fill='#fff'
      />
    </svg>
  );
};
export const InstructionLogo = CommInstructionLogo;

export const SwitchInstructionLogo = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='255.333'
      height='60'
      viewBox='0 0 255.333 60'
    >
      <g transform='translate(-4744 -2682)'>
        <g transform='translate(4536.336 2662)'>
          <path
            d='M35.02,27.34V25.26c0-4.8-3.48-8.4-10.12-8.4H16.02c-.72,0-.92-.4-.92-.88v-.16c0-.44.28-.76.92-.76H32.86V4.7H13.94C6.78,4.7,2.58,7.5,2.58,14.78v1.16c0,6.28,3.2,9.6,11.28,9.6h7.96c.52,0,.8.2.8.76v.12c0,.52-.2.76-.8.76H3.22V37.3H24.26C32.06,37.3,35.02,32.66,35.02,27.34Zm37.68.68V13.26H62.1V25.3c0,1.52-.72,1.92-2.24,1.92h-.32V13.26H51.26V27.22h-.24c-1.52,0-2.24-.4-2.24-1.92V13.26H38.18V28.02c0,5.64,3.56,9.36,9.72,9.36H62.98C69.18,37.38,72.7,33.66,72.7,28.02ZM88.26,13.74V4.7H76.78v9.04Zm0,23.64V15.58H76.78v21.8Zm32.92-13.64V13.22h-13V8.66H96.86v4.56h-5V23.74h5V29.5c0,4.76,2.36,7.88,9,7.88h14.76V26.94h-11c-1.28,0-1.44-.2-1.44-1.28V23.74Zm31.48,13.64V26.78H136.38c-1.08,0-1.6-.28-1.6-.96v-.96c0-.56.32-.96,1.56-.96h16.32V13.26H134.38c-8.24,0-10.84,3.92-10.84,10.32V27.1c0,6.48,2.4,10.28,10.88,10.28Zm34.2,0V23.14c0-7.36-3.08-9.88-9.48-9.88H170.9a7.022,7.022,0,0,0-2.64.6V4.7H156.74V37.38h11.52V25.82c0-1.36.44-1.92,1.76-1.92h3.56c1.36,0,1.76.68,1.76,1.76V37.38Z'
            transform='translate(276.137 29.1)'
            fill='#fff'
          />
        </g>
        <g transform='translate(4744 2682)'>
          <path
            d='M43.94,29.28H28.06A10.087,10.087,0,0,0,18,39.34v.84A10.087,10.087,0,0,0,28.06,50.24H43.94A10.087,10.087,0,0,0,54,40.18v-.84A10.087,10.087,0,0,0,43.94,29.28ZM28.527,44.213a4.453,4.453,0,1,1,4.447-4.453,4.38,4.38,0,0,1-4.447,4.453Z'
            transform='translate(-6 -9.76)'
            fill='#fff'
          />
          <path
            d='M30,0A30,30,0,1,0,60,30,30,30,0,0,0,30,0Zm0,57.6A27.6,27.6,0,1,1,57.6,30,27.6,27.6,0,0,1,30,57.6Z'
            fill='#fff'
          />
        </g>
      </g>
    </svg>
  );
};

export const SpeccText = {
  title: 'Communicate',
  mission: '正しく伝え読み取る力を身につける。',
  description_start: '説明(開始)',
  description_finish: '説明(終了)',
  video:
    'https://dl.dropboxusercontent.com/s/0zw6pts700228yk/6-1%E8%A7%A3%E8%AA%AC_1.mp4',
};

interface InstructionText {
  title: string;
  mission: string;
  description: string;
  video: string;
  video_result: string;
}

export const InstructionText: { [v: number]: InstructionText } = {
  1: {
    title: 'あやふやイメージ伝達',
    mission: '正しく相手に情報を伝え、正しく相手の意図を汲み取る',
    description:
      '2~3人で行うグループワークです。各々の画面には共通の写真が4枚、異なる写真が2枚表示されます。15分以内の会話で共通の写真を4枚選び、同じ順番で並べましょう。',
    video:
      'https://dl.dropboxusercontent.com/s/0zw6pts700228yk/6-1%E8%A7%A3%E8%AA%AC_1.mp4',
    video_result:
      'https://dl.dropboxusercontent.com/s/0zw6pts700228yk/6-1%E8%A7%A3%E8%AA%AC_1.mp4',
  },
  2: {
    title: '回数限定ディスカッション',
    mission: '情報を整理しながら話し、齟齬が生まれる原因を探る。',
    description:
      'ある1つのテーマに対して複数の選択肢が提示されます。決められた会話回数の中で議論をして、グループで1つの結論を出しましょう。各個人で議論内容を結論シートにまとめた後、全員のシートを比較します。理由の一致度や情報の抜け漏れを確認することで、会話の中で発生していた齟齬を認識しましょう。',
    video:
      'https://dl.dropboxusercontent.com/s/0zw6pts700228yk/6-1%E8%A7%A3%E8%AA%AC_1.mp4',
    video_result:
      'https://dl.dropboxusercontent.com/s/0zw6pts700228yk/6-1%E8%A7%A3%E8%AA%AC_1.mp4',
  },
};

export const InstructionColor: InstructionColors = {
  primary: '#956FFF',
  secondary: '#7A4AFF',
  finishButton: '#6B37FA',
  shadow: '#6338DB',
};
export const SwitchInstructionColor: InstructionColors = {
  primary: '#6C98FF',
  secondary: '#4F78FF',
  finishButton: '#426EFF',
  shadow: '#4167E4',
};
